import { useState } from 'react';

const HeroCard = ({ icon, title, description, delay = 0 }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="group relative p-5 md:p-8 rounded-2xl bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 hover-lift hover-border overflow-hidden cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ 
        animation: `fadeInUp 0.6s ease-out forwards`,
        animationDelay: `${delay}ms`,
        opacity: 0
      }}
    >
      {/* Background Gradient on Hover */}
      <div
        className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-primary/5 to-accent/5`}
      />

      {/* Shine Effect */}
      <div className="shine-on-hover relative z-10">
        {/* Icon */}
        <div className="w-10 h-10 md:w-14 md:h-14 rounded-xl bg-primary/10 dark:bg-accent/10 flex items-center justify-center mb-3 md:mb-4 group-hover:scale-110 transition-transform duration-300">
          <span className="text-xl md:text-2xl">{icon}</span>
        </div>

        {/* Content */}
        <h3 className="text-base md:text-xl font-semibold text-primary dark:text-white mb-1 md:mb-2 group-hover:text-accent transition-colors duration-300">
          {title}
        </h3>
        <p className="text-xs md:text-sm text-neutral-600 dark:text-neutral-300 leading-relaxed">
          {description}
        </p>

        {/* Decorative Elements */}
        <div className={`absolute top-2 right-2 md:top-4 md:right-4 w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-accent transition-all duration-300 ${isHovered ? 'scale-150 opacity-100' : 'scale-0 opacity-0'}`} />
      </div>

      {/* Border Animation */}
      <div className="absolute inset-0 border-2 border-transparent group-hover:border-accent/30 rounded-2xl transition-all duration-500" />
    </div>
  );
};

export default HeroCard;
